import { render, staticRenderFns } from "./AllocationIconV2.vue?vue&type=template&id=04ab6b09&scoped=true"
import script from "./AllocationIconV2.vue?vue&type=script&lang=js"
export * from "./AllocationIconV2.vue?vue&type=script&lang=js"
import style0 from "./AllocationIconV2.vue?vue&type=style&index=0&id=04ab6b09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab6b09",
  null
  
)

export default component.exports